import clientesApi from "@/app/services/clientes";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
    namespaced: true,
    state: {
      cliente: {},
      clientes: [],
      busca: ''
    },

    getters: {
      clientesSelect(state) {
        return state.clientes.map(cliente => {
          return {
            text: cliente.id + ' - ' + cliente.razao,
            value: cliente.id
          }
        })
      }
    },

    mutations: {
      listar(state, clientes) {
        state.clientes = clientes;
      },

      abrir(state, cliente) {
        state.cliente = cliente;
      },

      salvar(state, cliente) {
        state.clientes.push(cliente);
      },

      atualizar(state, cliente) {
        let index = state.clientes.findIndex(cliente_ => cliente_.id == cliente.id);
        if (index > -1) {
          state.clientes.splice(index, 1, cliente);
        }
      },

      excluir(state, id) {
        let index = state.clientes.findIndex(cliente => cliente.id == id);
        if (index > -1) {
          state.clientes.splice(index, 1);
        }
      },

      UNSET_CLIENTE(state) {
        state.cliente = {};
      },

      SET_BUSCA(state, busca) {
        state.busca = busca;
      }
    },

    actions: {
      async listar({commit}) {
        commit('LOADING_ON', null, {root: true});
        let clientes = await clientesApi.listar();
        commit('listar', clientes);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let cliente = await clientesApi.abrir(id);
        commit('abrir', cliente);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit, dispatch}, cliente) {
        let novoCliente = await clientesApi.salvar(cliente);
        commit('salvar', novoCliente);
      },

      async atualizar({commit}, cliente) {
        await clientesApi.atualizar(cliente);
        commit('atualizar', cliente);
      },

      async excluir({commit}, id) {
        await clientesApi.excluir(id);
        commit('excluir', id);
      }
    }
}
